module.exports = __webpack_public_path__ + "static/media/gobe-cover-01.4803e4e2.png";